<template>
    <div class="video-card-details-wrapper d-flex">
      <div class="date-text pr-3">{{ getDateStr(date) }}</div>
      <div class="tag">
        <div class="tag-underline"></div>
      </div>
    </div>
  </template>
  
  <script>
  import moment from "moment";
  
  export default {
    name: "video-card-details",
    props: ["date"],
    
    methods: {
      getDateStr(date) {
        let dateStrFormat = "MMM D YYYY"
        return date != null ? moment(date).format(dateStrFormat).toUpperCase() : "";
      }
    }
  };
  </script>
  
  <style scoped>
  .video-card-details-wrapper {
    color: #666666;
    font-weight: 600;
  }
  .tag {
    margin-top: -3px;
  }
  .tag-text {
    font-family: artifaktElementBold;
    font-size: 12px;
  }
  .tag-underline {
    height: 2px;
    background: #abe1a6;
    margin-top: -3px;
  }
  </style>


// WEBPACK FOOTER //
// src/components/homebase/campaigns/VideoCardDetails.vue